import * as React from "react";

export interface PageTitleProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}

export default function PageTitle({
  title,
  description,
  className = "",
}: PageTitleProps) {
  return (
    <div className={`mb-4 sm:mb-6 ${className}`}>
      <h1
        data-testid="page-title"
        className="text-page-title mb-1 sm:mb-2"
      >
        {title}
      </h1>
      {description && (
        <p className="text-xs sm:text-base text-secondary leading-snug">
          {description}
        </p>
      )}
    </div>
  );
}
